import { AfterViewInit, Component, DoCheck, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject, firstValueFrom, lastValueFrom } from 'rxjs';
import { CensusListService } from 'src/app/includes/census-list/census-list..service';
import { PatientRoundingSheetService } from 'src/app/includes/patient-rounding-sheets/patient-rounding-sheet.service';
import { AuthService } from 'src/app/services/auth.service';
import { MipsService } from 'src/app/services/Modules/mips.service';
import { NoteAddChargeService } from '../note-add-charge.service';
import * as global from '../../../global';
import { CompanyService } from 'src/app/services/Modules/company.service';
import moment from 'moment';
import { FaceSheetService } from 'src/app/includes/patient-detail/facesheet/face-sheet.service';
import { UpdatePatientInfoDialogComponent } from '../../update-patient-info-dialog/update-patient-info-dialog.component';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { PatientDocumentsUploadDialog } from 'src/app/includes/patient-documents-list/patient-documents-upload-dialog/patient-documents-upload-dialog.component';
import { CommonService } from 'src/app/services/common.service';
import { SidebarMipsComponent } from 'src/app/components/sidebar-addCharges/sidebar-mips/sidebar-mips.component';
import { DialogConfirmationComponent } from 'src/app/includes/census-patient-list/dialog-confirmation/dialog-confirmation.component';
import { CommentsComponent } from 'src/app/components/sidebar-addCharges/comments/comments/comments.component';
export interface ChargeAction {
  action: any,
  data: any
}
@Component({
  selector: 'app-note-add-charge',
  templateUrl: './note-add-charge.component.html',
  styleUrls: ['./note-add-charge.component.css']
})
export class NoteAddChargeComponent implements OnInit, DoCheck, OnDestroy {

  @Input() note: any;
  @Input() relationship: any;
  @Input() noteEditorIcds: any[] = [];
  @Input() noteEditorCpts: any[] = [];
  @Input() emCodeEditorCpts: any[] = [];
  @Input() telemedPhrase: any = false
  @Input() signedNotesStatus: any;
  @Input() carryChargeStatus: any;
  @Input() companySubmitMipsStatus: any;
  @Output() sidebarClose = new EventEmitter<boolean>();
  @Output() onChargeChange = new EventEmitter<any>();
  @Output() onChargeAndICDChange = new EventEmitter<any>()
  @Output() onPhrasesChange = new EventEmitter<any>();
  @Output() noteEditorCptsChange = new EventEmitter<any>()
  @Output() noteEditorIcdsChange = new EventEmitter<any>()
  @Output() submitButonClicked = new EventEmitter<any>();


  @ViewChild('tabGroup') tabGroup;
  showMips: boolean = false;
  showMipsToaster: boolean = true;
  showCPTs = true;
  showICDs = true;
  chargesLoader: Boolean = false;
  charge: any = {};
  charge_status ='';
  currentUser: any;
  rs_id;
  patient_id;
  facility_id;
  provider_id;
  params: any = {};
  carryOverCharge = {};
  reportMeasure: Boolean = false;
  disableClick: Boolean = false;
  recentMips:any;
  tabIndex: Number = 0;
  model = {
    owner_id: '',
    patient_id: '',
    rounding_sheet_id: '',
    icd_id: [],
    cpt_id: [],
    billing_note: '',
    note: '',
    status: '',
    visit_date: '',
    facility_id: '',
    measure: false,
    charge_id: '',
    cpt_modifiers: [],
    cpt_pos: [],
    is_approved: "false",
    note_id: '',
    patient_first_name:'',
    patient_last_name:'',
    patient_dob:'',
    patient_gender:'',
    source:'',
    date_obj: null
    // coSignedProvider: ''
  };
  mipPayload = {};
  subscriptions: any[] = [];
  isChargeLoading: BehaviorSubject<boolean> = new BehaviorSubject(null);
  cptsExist: BehaviorSubject<boolean> = new BehaviorSubject(null);
  icdsExist: BehaviorSubject<boolean> = new BehaviorSubject(null);
  submitDoclose: boolean = false;
  global = global;

  buttonStates = {
    saveAsDraft: false
  }
  originalChargeState;
  setTimeOutId: NodeJS.Timeout;
  questionnaireResults:any;
  hideMipsReportMeasure: boolean = false;
  autoSaveMessage: string;
  isFacesheetMandatoryToSubmitCharge: boolean = false;
  chargeForMips: any;
  submittedMips: any = [];
  availableMips: any;
  denominatorCalulationInProgressValue: any = false;
  @ViewChild(SidebarMipsComponent) _sidebarMipsComponent: SidebarMipsComponent;
  @ViewChild(CommentsComponent) _commentsComponent: CommentsComponent;

  company_id: any = '';
  mipSubscription: any;

  constructor(
    private censusListService: CensusListService,
    private route: ActivatedRoute,
    private authService: AuthService,
    private service: PatientRoundingSheetService,
    private toastr: ToastrService,
    private patientRoundingSheetService: PatientRoundingSheetService,
    private mipsService: MipsService,
    private dialog: MatDialog,
    private _noteAddChargeService: NoteAddChargeService,
    private _company: CompanyService,
    private _faceSheetService: FaceSheetService,
    private commonService: CommonService,
    private _router: Router,

  ) {
    this.patient_id = this.route.snapshot.paramMap.get('patient_id');
    this.rs_id = this.route.snapshot.paramMap.get('census_id');
    this.facility_id = this.route.snapshot.paramMap.get('facility_id');
    this.provider_id = this.route.snapshot.paramMap.get('provider_id');
    this.params = {
      rs_id: this.rs_id,
      patient_id: this.patient_id,
      facility_id: this.facility_id,
      provider_id: this.provider_id,
    }
    this.currentUser = this.authService.currentUser;
  }

  async ngOnInit() {
    if(this._router.url.includes("/company")) {
      this.company_id = this.route.snapshot.parent.params.id;
    }
    await this.initCharge();
    this.getrecentMip()
    this._sidebarMipsComponent?.refreshMeasuresonInit();
    this.autoSaveMessage='';
    this._noteAddChargeService.setisCPT(false);
    this._noteAddChargeService.setisICD(false);
    if (this.authService.currentUser.user_type === global.USER_TYPE.TRANSCRIBER || this.authService.currentUser.user_type === global.USER_TYPE.MEDICAL_ASSISTANT) {
      this.model.owner_id = this.note.provider._id;
    }
    else {
      this.model.owner_id = this.authService.currentUser._id;
    }
    if(this.charge){
      await this.initQuestionaireResults();
    }
    this.saveOriginalChargeState();
    await this.checkFacesheetStatus();
  }

  async checkFacesheetStatus() {
    this._faceSheetService.checkFacesheetStatusForCompany(this.currentUser.company_id).subscribe((res:any)=> {
      if(res.status == 200) {
        this.isFacesheetMandatoryToSubmitCharge = res.data.should_upload_facesheet;
      }else {
        console.log('something went wrong');
      }
    });
  }

  ngDoCheck() {
    this.doCheckButtonStates();
  }

  doCheckButtonStates() {
    if (this.disableButtonForDraft() || this.disableClick) {
      this.buttonStates.saveAsDraft = false;
      return;
    }
    if (this.isChargeTouched()) {
      if(this.model.cpt_id.length == 0 && this.model.icd_id.length == 0){
        this.buttonStates.saveAsDraft = false;
      }else{
        this.buttonStates.saveAsDraft = true;
      }
    } else {
      this.buttonStates.saveAsDraft = false;
    }
  }

  isChargeTouched() {
    return !this.compareOriginalChargeState()
  }

  compareOriginalChargeState() {
    const _model = { ...this.model };
    _model.icd_id = this.model.icd_id.map(icd => typeof icd === 'string' ? icd : icd._id)
    _model.cpt_id = this.model.cpt_id.map(cpt => typeof cpt === 'string' ? cpt : cpt._id)

    return JSON.stringify(_model) === this.originalChargeState;
  }
  async getrecentMip(){
    this.availableMips = [];
    this.submittedMips = [];
    const details = {
      patient_id: this.note.patient._id,
      owner_id : this.note.provider._id,
      rounding_sheet_id : this.note.rounding_sheet_id
    }
    this.service.getrecentMip(details).subscribe((res: any) => {
      if (res.data.allMips?.length > 0) {
        let year = this.note.date_obj.year;
        let recentOneMip;
        if(res.data.recentOneMip){
          recentOneMip = res.data.recentOneMip;
        }
        let allRecentMips = res.data.allMips.filter((mip: any) => mip.date_obj?.year == year);
        if(allRecentMips.length >= 0){
          allRecentMips = allRecentMips.map((mip: any) => {return mip.recentMip;});
          allRecentMips = [].concat(...allRecentMips);
          allRecentMips = allRecentMips.filter((obj, index, self) => index === self.findIndex(q => q.measure_id[0]?._id?.toString() == obj.measure_id[0]?._id?.toString()));
          recentOneMip.recentMip = allRecentMips;
        }
        this.recentMips = recentOneMip;

        if (this.recentMips) {
          this.submittedMips = this.recentMips.recentMip;
        }
      }
      // console.log("this.mipsInTh isYear() : ", this.mipsInThisYear());
    })

  }

  async checkRecentMipForCharge() {
    const details = {
      patient_id: this.note.patient._id
    }
    this.service.getrecentMip(details).subscribe((res: any) => {
      if (res.data.allMips?.length > 0) {
        let year = this.note.date_obj.year;
        let recentOneMip;
        if(res.data.recentOneMip){
          recentOneMip = res.data.recentOneMip;
        }
        let allRecentMips = res.data.allMips.filter((mip: any) => mip.date_obj?.year == year);
        if(allRecentMips.length >= 0){
          allRecentMips = allRecentMips.map((mip: any) => {return mip.recentMip;});
          allRecentMips = [].concat(...allRecentMips);
          allRecentMips = allRecentMips.filter((obj, index, self) => index == self.findIndex(q => q.measure_id[0]?._id?.toString() == obj.measure_id[0]?._id?.toString()));
          recentOneMip.recentMip = allRecentMips;
        }
        this.recentMips = recentOneMip;

        if (this.recentMips) {
          this.submittedMips = this.recentMips.recentMip;
        }
      }
    })
  }

  saveOriginalChargeState() {
    const _model = { ...this.model };
    _model.icd_id = this.model.icd_id.map(icd => typeof icd === 'string' ? icd : icd._id)
    _model.cpt_id = this.model.cpt_id.map(cpt => typeof cpt === 'string' ? cpt : cpt._id)
    return this.originalChargeState = JSON.stringify(_model);
  }
  async initCharge() {
    this.chargesLoader = false
    const details = {
      patient_id: this.note.patient._id,
      rounding_sheet_id: this.note.rounding_sheet_id,
      visit_date: this.note.dates.service,
      status: null
    }
    // this.isChargeLoading.next(true);
    let response: any = await this.censusListService.getCharge(details, this.company_id).toPromise();
    if (response.status === 200) {
      this.charge = response.data;
      this.mipPayload = this.charge
      this.charge_status =this.charge?.status || '';
      //if there is no drafted charge than we will get most recent charge based on owner and patient ids
      if (response.data == null && this.carryChargeStatus) {
        let res: any = await this.service.getRecentCharge(details).toPromise()
        if (res.status == 200) {
          this.carryOverCharge = res.data;
          this.charge = this.carryOverCharge;
          //deleting this status property to avoid any flags manipulatoin as we'll just carying this charge as hint
          delete this.charge.status;
        }
        // this.isChargeLoading.next(null);
      } else {
        // this.isChargeLoading.next(false);
      }
      if (!this.charge?.status || this.charge?.status !== "submit") {
        this.isChargeLoading.next(false);
      }
      else {
        this.isChargeLoading.next(null);
      }
      if (this.note) {
        this.model.visit_date = this.note.dates.service;
        this.model.rounding_sheet_id = this.note.rounding_sheet_id;
        this.model.patient_id = this.note.patient._id;
        this.model.facility_id = this.note.facility._id;
        this.model.note_id = this.note._id;
        // this.model.patient_first_name=this.note.patient.first_name;
        // this.model.patient_last_name=this.note.patient.last_name;
        // this.model.patient_dob=this.note.patient.date_of_birth;
        // this.model.patient_gender=this.note.patient.gender;
        // this.model.source=this.note.patient.source;
      }
      // reason to check this.charge.status is that we only previoulsy existed charge will have status otherwise we'll create new one
      if (this.charge && this.charge.status) {
        if(this.charge._id){
          this.model.charge_id = this.charge._id;
          this.chargeForMips=this.charge;
        }
        this.model.cpt_modifiers = this.charge.cpt_modifiers;
        this.model.cpt_pos = this.charge.cpt_pos;
        this.model.note = this.charge.note;
        // this.model.patient_first_name = this.charge.patient_first_name;
        // this.model.patient_last_name = this.charge.patient_last_name;
        // this.model.patient_dob = this.charge.patient_dob;
        // this.model.patient_gender = this.charge.patient_gender;
        this.model.cpt_id = this.charge?.cpt_id || [];
        this.model.icd_id = this.charge?.icd_id || [];
        if(this.model.cpt_id.length > 0 || this.model.icd_id.length > 0){
          this.noteEditorCptsChange.emit(this.charge.cpt_id);
        }
      }else{
        if(this.charge?.cpt_id && this.charge?.icd_id){
          this.model.cpt_id = this.charge?.cpt_id;
          this.model.icd_id = this.charge?.icd_id;
          this.noteEditorCptsChange.emit(this.charge.cpt_id);
        }
      }
      if(this.charge && this.charge.date_obj){
        this.model.date_obj = this.charge.date_obj;
      }
      this.chargesLoader = true;
      this.onChargeChange.emit(this.model);
    }
  }
  async saveData() {
    await this.addCharge('draft', false, "false");
    this.saveOriginalChargeState()
    if(this.tabIndex ==1) this.charge_status = 'draft';
  }
  async submitCharge() {
    this.submitButonClicked.emit(true);
    this.disableClick=true;
    if(!this.model.date_obj) {
      this.model.date_obj = this.note.date_obj;
    }
    let date_obj_string = this.commonService.dateObjToString_format2(this.model.date_obj,false);
    let future_date_obj:any = this.commonService.splitMomentToObj(moment());
    future_date_obj.day = future_date_obj.day + 1;
    if (moment(date_obj_string).isSameOrAfter(this.commonService.dateObjToString_format2(future_date_obj,false))) {
      this.toastr.error("Charge cannot be submitted in future date of service", "Error");
      this.disableClick=false;
      return;
    }

    let canSubmitChargeWithMupltipleCpts = false;
    [canSubmitChargeWithMupltipleCpts] = await this._company.checkCompanyPermission(["allow_multiple_cpts"], this.currentUser.company_id);

    if(this.model.cpt_id.length ===1 && this.model.icd_id.length > 0){
      if (this.signedNotesStatus) {
        if (this.note.is_signed === "true") {
          console.log('heeeeeeeeeee');
          this.checkFacesheetAndSubmitCharge();

        } else {
        this.disableClick=false;
          this.toastr.info("Note must be signed first before submitting the charges");
        }
      } else {
        await this.checkFacesheetAndSubmitCharge();
      }
    }
    else if (this.model.cpt_id.length > 1 && this.model.icd_id.length > 0) {
      if (!canSubmitChargeWithMupltipleCpts) {
        let dialogRef = this.dialog.open(DialogConfirmationComponent, {
          data: {
            message: 'You have selected more than one CPT <br> Are you sure to submit?'
          }
        });
        dialogRef.afterClosed().subscribe(async result => {
          if (result === 'true') {
            if (this.signedNotesStatus) {
              if (this.note.is_signed === "true") {
                this.checkFacesheetAndSubmitCharge();
              } else {
                this.disableClick = false;
                this.toastr.info("Note must be signed first before submitting the charges");
              }
            } else {
              await this.checkFacesheetAndSubmitCharge();
            }
          }
          else if (result === 'false') {
            this.disableClick = false;
            dialogRef.close();
          }
        }
        )
      }
      else {
        if (this.signedNotesStatus) {
          if (this.note.is_signed === "true") {
            this.checkFacesheetAndSubmitCharge();
          } else {
            this.disableClick = false;
            this.toastr.info("Note must be signed first before submitting the charges");
          }
        } else {
          await this.checkFacesheetAndSubmitCharge();
        }
      }
    }else if(this.model.cpt_id.length == 0){
      this.disableClick=false;
      this.toastr.error("Atleast 1 Charge should be selected");
    }else{
      this.disableClick=false;
      this.toastr.error("Atleast 1 Diagnose should be selected");
    }
    
  }

  async getMipAvailableAndSubmitStatus(){
    return new Promise(async (resolve, reject) => {
      const questionnaireResults = await firstValueFrom(this.mipsService.castQuestionnaireResults);
          console.log("questionnaireResults?.length, this.availableMips?.length", questionnaireResults?.length, this.availableMips?.length);
          if (Array.isArray(questionnaireResults) && questionnaireResults.length > 0) {
            if(this.availableMips&&(this.availableMips.length==questionnaireResults.length)){
              resolve(true);
            }else{
              resolve(false);
            }
          }else{
            if(this.recentMips){
              resolve(true);
            }else if(this.availableMips&&this.availableMips.length>0){
              resolve(false);
            }
          }
          resolve(true);
    });
  }

  availableMipsEvent(e){
    this.availableMips=e;
  }

  showMipsToasterOnce(e) {
    this.showMipsToaster =  e;
  }

  async checkFacesheetAndSubmitCharge() {
    this.disableClick=true;
    console.log('this.companySubmitMipsStatus&&this.currentUser.mip_reporting',this.companySubmitMipsStatus, this.currentUser.mip_reporting);

    if(this.companySubmitMipsStatus&&this.currentUser.mip_reporting){
      await this.checkRecentMipForCharge();
      let statuss = await this.getMipAvailableAndSubmitStatus();
      console.log("user mips enabling statuss", statuss);
      if(this.submittedMips&&this.submittedMips.length>0){
        console.log("pass /// mips already done")
      }
      else if(!statuss){
        this.toastr.info("Please complete MIPS Questionnaire first");
        this.disableClick=false;
        return;
      }
    }

    if ((!this.note.patient.source) && this.note.patient.source != 'PointClickCare' && this.note.patient.source != 'MatrixCare') {
      console.log('hemlloooooo!!!');
      const checkFacesheet: any = await this.getPatientFacesheet();
      if (!(checkFacesheet.message === "No facesheet found!")) {
          // this.openEditPatientDialog();
          await this.addCharge();
          this.saveOriginalChargeState();
          this.charge_status = 'submit';
      } else {
          if (this.isFacesheetMandatoryToSubmitCharge) {
              await this.showPatientsDialog("faceSheet");
          } else {
              // this.openEditPatientDialog();
            await this.addCharge();
            this.saveOriginalChargeState();
            this.charge_status = 'submit';
        }
      }
    } else {
      //  this.openEditPatientDialog();
        await this.addCharge();
        this.saveOriginalChargeState();
        this.charge_status = 'submit';
    }
  }

  openEditPatientDialog() {
    const dialogRef = this.dialog.open(
      UpdatePatientInfoDialogComponent,
      {
          width: "600px",
          data: {
              patient_first_name: this.model.patient_first_name,
              patient_last_name: this.model.patient_last_name,
              patient_dob: this.model.patient_dob,
              patient_gender: this.model.patient_gender.charAt(0) +this.model.patient_gender.substring(1).toLowerCase(),
              title: "Update Patient Info"
          }
      }
    );
    dialogRef.afterClosed().subscribe(async (data) => {
      console.log(data);
      if (data) {
        this.model.patient_first_name = data.patient_first_name;
        this.model.patient_last_name = data.patient_last_name;
        this.model.patient_dob = data.patient_dob;
        this.model.patient_gender = data.patient_gender;
        await this.addCharge();
        this.saveOriginalChargeState();
        this.charge_status = 'submit';
      }
    });
  }

  async getPatientFacesheet() {
    let res = await this._faceSheetService.getFacesheet(this.note.patient._id).toPromise();
      return res;
  }

  async showPatientsDialog(type) {
    const dialogRef = this.dialog.open(
      PatientDocumentsUploadDialog,
      { width: '80%', data: { patient: this.note.patient._id } }
    );
    dialogRef.beforeClosed().subscribe(async (fileInput: any) => {
      if (fileInput) {
        const [file] = fileInput.files;
        const infoToast = this.toastr.info('Uploading Document...', 'Please wait')

        try {
          const company_id = this.authService.currentUser.company_id;
          if (type === "faceSheet") {
            this._faceSheetService.uploadFaceSheet(file, this.note.patient._id, company_id).subscribe(async(response: any) => {
              if (response.data) {
                this.toastr.success("Face Sheet Uploaded", 'Success');
                await this.addCharge();
                this.saveOriginalChargeState();
                console.log('facesheet uploaded and charge submitted');
              }
              else {
                console.error(response.data.status, response.data.message);
                this.toastr.error(response.data.message, 'Failed');
              }
            });
          }
        } catch (error) {
          this.toastr.error('Something went wrong please try again', 'Failed');

        } finally {
          this.toastr.clear(infoToast.toastId);
        }
      }
    });
    dialogRef.afterClosed()
  }

  showAutoSaveMessage(){
    this.autoSaveMessage = "Charges Auto Saved at: " + moment(new Date()).format('HH:mm:ss').toString();
  }

  async AutoaddCharge(statuss = 'submit', doClose = true, approved = "true", type?) {
    if(this.model.cpt_id.length > 0 || this.model.icd_id.length > 0){
      //remove if there is any expired icd exists in model
      this.model.icd_id = this.model.icd_id.filter(icd => {
        if (icd.end_date && icd.end_date !== "") {
            const [month, day, year] = icd.end_date.split("/");
            if (moment(`${year}-${month}-${day}`).isBefore(moment())) {
                return false; 
            }
        }
        return true;
      });
      this.model.status = statuss;
      if(this.tabIndex ==1) this.charge_status = statuss
      this.model.is_approved = approved;
      if (this.submitDoclose) {
        doClose = false;
      }
      
      this.cptsExist.next(true);
      this.icdsExist.next(true);
  
      this.disableClick = true;
    
      this.model.cpt_id = Array.from(new Set(this.model.cpt_id));
      this.model.icd_id = Array.from(new Set(this.model.icd_id));
      const res: any = await this.patientRoundingSheetService.addCharge(this.model).toPromise();
      if (res.status == 200) {
        this.disableClick = false;

        this.saveOriginalChargeState();
        this.model.charge_id = res.data.array[0]._id;
        this.model.date_obj = res.data.array[0].date_obj;
        this.submitDoclose = false;
        this.model.measure = false;
        this._commentsComponent.setChargeProps(res.data.array[0]._id, res.data.array[0].status);
        const [charge] = res.data.array;
        this.chargeForMips=charge;
        if(statuss=='submit'){
          const questionnaireResults = await firstValueFrom(this.mipsService.castQuestionnaireResults);
          if (Array.isArray(questionnaireResults) && questionnaireResults.length > 0) {
            this.mipsService.saveQuestionnareResults(questionnaireResults.map(r => ({ measure_id: r.measure._id, answer: r.answer, matched: r.measure.matched, reasons:r.reasons, question_id:r.question_id })), charge._id, this.currentUser.company_id)
            .subscribe((res:any)=>{
              this.getrecentMip();
              this.toastr.success('MIPS are Submitted Successfully', 'Success');
              this.mipsService.setQuestionnairesResult([]);
              this._sidebarMipsComponent?.refreshMeasuresonInit();
              this.getrecentMip();
            })
          }
        }else{
          this._sidebarMipsComponent?.refreshMeasuresonInit();
          this.getrecentMip();
        }
        return res;
      }
      else if (res.status === 500) {
        this.toastr.error(res.message, "ERROR");
      }
    }
  }

  getMipsValueForButton(){
    let resp=true;
    this.mipsService.castQuestionnaireResults.subscribe(res=>{
      // console.log("questionnaireResults : ",!(Array.isArray(res) && res.length >0));
      if (Array.isArray(res) && res.length >0) {
        resp= false;
      } 
      else 
        resp= true;
    });
    return resp;
  }
 
  denominatorCalulationInProgress(e){
    this.denominatorCalulationInProgressValue=e;
  }

  getRecentMipsEvent(e){
    if(e){
      this.getrecentMip();
    }
  }

  getRecentMipsAgainEvent(e){
    if(e){
      this.getrecentMip()
      this._sidebarMipsComponent?.refreshMeasuresonInit();
    }
  }

  async saveMipsasDraft(){
    const questionnaireResults = await firstValueFrom(this.mipsService.castQuestionnaireResults);
    if (Array.isArray(questionnaireResults) && questionnaireResults.length > 0&&this.chargeForMips) {
      // console.log("questionnaireResults : ",questionnaireResults);
      this.mipsService.draftQuestionnareResults(questionnaireResults.map(r => ({ measure_id: r.measure._id, answer: r.answer, matched: r.measure.matched, reasons:r.reasons, question_id:r.question_id })), this.model.charge_id||this.chargeForMips._id, this.currentUser.company_id)
        .toPromise();
      // this.mipsService.setQuestionnairesResult([]);
    }
  }

  async addCharge(statuss = 'submit', doClose = true, approved = "true", type?) {
    this.model.status = statuss;
    this.model.is_approved = approved;
    if (this.submitDoclose) {
      doClose = false;
    }
    // if (this.model.cpt_id.length > 0 && this.model.icd_id.length <= 0) {
    //   this.cptsExist.next(true);
    //   this.icdsExist.next(false);
    //   this.toastr.error("Select Diagnosis")
    //   return;
    // } else if (this.model.icd_id.length > 0 && this.model.cpt_id.length <= 0) {
    //   this.cptsExist.next(false);
    //   this.icdsExist.next(true);
    //   this.toastr.error("Select Charges")
    //   return;
    // } else if (this.model.icd_id.length <= 0 && this.model.cpt_id.length <= 0) {
    //   this.cptsExist.next(false);
    //   this.icdsExist.next(false);
    //   return;
    // }
    // else {
      this.cptsExist.next(true);
      this.icdsExist.next(true);
    // }
    // this.censusPatientListService.castCptModifiersForCharge.subscribe(cpt_modifier => {
    //   this.model.cpt_modifiers = cpt_modifier || this.charge.cpt_modifiers;
    // })

    // if(this.note.coSign_status.coSigned_by){
    //   this.model.coSignedProvider = this.note.coSign_status.coSigned_by;
    // }

    // this.reset.emit(true);
    // console.log("in note add charge screen: ", this.model);
    // this.sidebarClose.emit(true);
    this.disableClick = true;
    // this.hideMipsReportMeasure = true;
    this.model.cpt_id = Array.from(new Set(this.model.cpt_id));
    this.model.icd_id = Array.from(new Set(this.model.icd_id));
    console.log('this.model....',this.model);
      //remove if there is any expired icd exists in model
      this.model.icd_id = this.model.icd_id.filter(icd => {
        if (icd.end_date && icd.end_date !== "") {
            const [month, day, year] = icd.end_date.split("/");
            if (moment(`${year}-${month}-${day}`).isBefore(moment())) {
                console.log('expired icd spotted', icd);
                return false; // Exclude this element from the filtered array
            }
        }
        return true; // Include this element in the filtered array
    });
    const res: any = await this.patientRoundingSheetService.addCharge(this.model).toPromise();
    if (res.status == 200) {
      this.disableClick = false;

        if (this.charge?.status) {
        if( statuss === "submit"){
          this.toastr.success('Charge is Submitted Successfully', 'Success');
        }else{
          if (JSON.stringify(this.charge.icd_id.map(a => a._id)) !== JSON.stringify(this.model.icd_id) ||
          JSON.stringify(this.charge.cpt_id.map(a => a._id)) !== JSON.stringify(this.model.cpt_id)) {
            this.toastr.success('Charge updated', 'Success');
          }
        }
      }
      else {
        if( statuss === "submit"){
          this.toastr.success('Charge is Submitted Successfully', 'Success');
        }else{
          this.toastr.success('Charge created', 'Success');
        }
      }
      this.model.charge_id = res.data.array[0]._id;
      this.model.date_obj = res.data.array[0].date_obj;
      // this.onChargeChange.emit(this.model);
      this.submitDoclose = false;
      // this.model.note = '';
      this.model.measure = false;
      const [charge] = res.data.array;
      this.chargeForMips=charge;
      if(statuss=='submit'){
        const questionnaireResults = await firstValueFrom(this.mipsService.castQuestionnaireResults);
        if (Array.isArray(questionnaireResults) && questionnaireResults.length > 0) {
          this.mipsService.saveQuestionnareResults(questionnaireResults.map(r => ({ measure_id: r.measure._id, answer: r.answer, matched: r.measure.matched, reasons:r.reasons, question_id:r.question_id  })), charge._id, this.currentUser.company_id)
          .subscribe((res:any)=>{
            this.getrecentMip();
            this.toastr.success('MIPS are Submitted Successfully', 'Success');
            this.mipsService.setQuestionnairesResult([]);
            this._sidebarMipsComponent?.refreshMeasuresonInit();
            this.getrecentMip();
          })
        }
      }else{
        this._sidebarMipsComponent?.refreshMeasuresonInit();
        this.getrecentMip();
      }
    }
    else if (res.status === 500) {
      this.toastr.error(res.message, "ERROR");
    }

  }
  ngOnDestroy(): void {
    this._noteAddChargeService.setisCPT(false);
    this._noteAddChargeService.setisICD(false);
    this.cptsExist.next(null);
    this.icdsExist.next(null);
    this.isChargeLoading.next(null);
  }
  cancel() {
    this.sidebarClose.emit(true);
    // this.showCPTs = false;
    // this.showICDs = false;
    // setTimeout(() => {
    //   // this.censusPatientListService.setCPTsForCharge([])
    //   // this.censusPatientListService.setICDsForCharge([])
    //   // this.censusPatientListService.setCPTModifiersForCharge([]);
    //   this.showCPTs = true;
    //   this.showICDs = true;
    // }, 1000);
  }

  disableButton() {
    if(this.note.coSign_status.status) {
      if((this.note.coSign_status.coSigned_to == this.currentUser._id || this.note.coSign_status.coSigned_by == this.currentUser._id)
        && (this.model?.status != 'submit' || this.charge?.status != "submit")
        && (!this.companySubmitMipsStatus && !this.currentUser.mip_reporting && !this.denominatorCalulationInProgressValue)
        && (this.model.icd_id.length >= 0 || this.model.cpt_id.length >= 0)
      ) {
        this.hideMipsReportMeasure = false;
        return false;
      }
      else {
        if (this.model?.status == 'submit' || this.charge?.status == "submit") {
          this.hideMipsReportMeasure = false;
          return true;
        }
        if(this.companySubmitMipsStatus&&this.currentUser.mip_reporting&&this.denominatorCalulationInProgressValue){
          setTimeout(() => {
            this.denominatorCalulationInProgressValue=false;
          }, 3500);
          this.hideMipsReportMeasure = false;
          return true;
        }
        if (this.model.icd_id.length <= 0 || this.model.cpt_id.length <= 0) {
          if (this.model.icd_id.length <= 0 && this.model.cpt_id.length <= 0){
            this.hideMipsReportMeasure = true;
          }
          return true;
        }
        else {
          this.hideMipsReportMeasure = false;
          return false;
        }
      }   
    }
    else {
      if (this.note?.provider?._id !== this.currentUser._id) {
        if (this.relationship?.assoc_ma_ids?.includes(this.currentUser._id.toString())) { 
          this.hideMipsReportMeasure = false; 
        }else{
          this.hideMipsReportMeasure = true;
        }
        return true;
      }
      if (this.model?.status == 'submit' || this.charge?.status == "submit") {
        this.hideMipsReportMeasure = false;
        return true;
      }
      if(this.companySubmitMipsStatus&&this.currentUser.mip_reporting&&this.denominatorCalulationInProgressValue){
        setTimeout(() => {
          this.denominatorCalulationInProgressValue=false;
        }, 3500);
        this.hideMipsReportMeasure = false;
        return true;
      }
      if (this.model.icd_id.length <= 0 || this.model.cpt_id.length <= 0) {
        if (this.model.icd_id.length <= 0 && this.model.cpt_id.length <= 0){
          this.hideMipsReportMeasure = true;
        }
        return true;
      }
      else {
        this.hideMipsReportMeasure = false;
        return false;
      }
    }
    
  }

  disableButtonForDraft() {
    if (this.currentUser.user_type === global.USER_TYPE.TRANSCRIBER || this.currentUser.user_type === global.USER_TYPE.MEDICAL_ASSISTANT) {
      if (this.model?.status == 'submit' || this.charge?.status == "submit") {
        return true;
      }
      return false;
    }
    if (this.note?.provider?._id !== this.currentUser._id) {
      return true;
    }
    if (this.model?.status == 'submit' || this.charge?.status == "submit") {
      return true;
    }
    else {
      return false;
    }
  }
  tabChange(e) {
    this.tabIndex = e.index;
    this.showMips = e.tab.textLabel === 'Charges'
  }
  navigate() {
    this.tabIndex = 1;
  }
  cptsChange(cptsData) {
    this.model.cpt_id = cptsData.map((c) => c._id);
    clearTimeout(this.setTimeOutId);
    this.setTimeOutId = setTimeout(() => {
      if (this.buttonStates.saveAsDraft) {
        this.onChargeAndICDChange.emit(true);
      }
    }, 2000);
    // if (this.model.cpt_id.length > 0) {
      this.onChargeChange.emit(this.model);
      this.cptsExist.next(true);
      this.noteEditorCptsChange.emit(cptsData);
    // }
    // else {
    //   this.cptsExist.next(false)
    // }
  }
  icdsChange(selectedIcds) {
    // this.model.icd_id = icds.map(icd=> icd._id);
    console.log('selectedIcds',selectedIcds);
    if(Array.isArray(selectedIcds.icds)) {
      this.model.icd_id = selectedIcds.icds.map(icd=> icd._id);
    } else {
      this.model.icd_id = selectedIcds.map(icd=> icd._id);
    }
    this.noteEditorIcdsChange.emit(selectedIcds);
    this.onChargeChange.emit(this.model);
    clearTimeout(this.setTimeOutId);
    this.buttonStates.saveAsDraft = true;
    // this.setTimeOutId = setTimeout(() => {
      if (this.buttonStates.saveAsDraft) {
        this.onChargeAndICDChange.emit(true);
      }
    // }, 2000);
    // if (this.model.icd_id.length > 0) {
      this.icdsExist.next(true);
    // }
    // else {
    //   this.icdsExist.next(false)
    // }
    console.log('final.......', this.model);
    
  }
  modifiersChange(modifiers) {
    this.model.cpt_modifiers = modifiers;
    // console.log("this.model", this.model);
    this.onChargeChange.emit(this.model);
    clearTimeout(this.setTimeOutId);
    if(this.model.cpt_id.length > 0 && this.model.icd_id.length > 0){
      this.setTimeOutId = setTimeout(() => {
        if (this.buttonStates.saveAsDraft) {
          this.onChargeAndICDChange.emit(true);
        }
      }, 2000);
    }
  }
  posChange(pos) {
    this.model.cpt_pos = pos;
    this.onChargeChange.emit(this.model);
    clearTimeout(this.setTimeOutId);
    if (this.model.cpt_id.length > 0 && this.model.icd_id.length > 0) {
      this.setTimeOutId = setTimeout(() => {
        if (this.buttonStates.saveAsDraft) {
          this.onChargeAndICDChange.emit(true);
        }
      }, 2000);
    }
  }
  comments(billerNote) {
    this.model.note = billerNote;
    this.onChargeChange.emit(this.model);
  }
  mipReportMeasure(event) {
    this.model.measure = event;
    this.reportMeasure = event;
  }
  mipsInThisYear(){
    if(this.recentMips){
      let year=(new Date()).getFullYear();
      let mipYear = this.recentMips?.date_obj?.year;

      if(mipYear==year) return true;
      mipYear=(new Date(this.recentMips.createdAt)).getFullYear();

      if(mipYear==year) return true;
      else return false;
    }
    return false;
  }
  isMipReportingEnabled() {
    return !this.hideMipsReportMeasure;
  }
  async initQuestionaireResults() {
    const response:any = await lastValueFrom(this.mipsService.getQuestionnareResults(this.charge._id, this.currentUser.company_id));
    if(response.status === 200 && response.data.array.length > 0) {
      this.questionnaireResults = response.data.array;
    }
  }
  mipsExists() { 
    return Array.isArray(this.questionnaireResults) && this.questionnaireResults.length > 0;
  }
  handleRemovePhrasesfromHtmlText($event) {
      this.onPhrasesChange.emit($event);
  }
}
